function updateSwiperCursor(swiper) {
  const swiperWrapper = swiper.el.querySelector('.swiper-wrapper')
  if (swiper.snapGrid.length > 1 || swiper.slides.length > swiper.params.slidesPerView) {
    swiperWrapper.style.cursor = 'grab'
  } else {
    swiperWrapper.style.cursor = 'auto'
  }
}

export const swiperEvents = {
  init: function () {
    updateSwiperCursor(this)
  },
  observerUpdate: function () {
    updateSwiperCursor(this)
  },
}
